import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import WorkersTab from "../../../shared/components/tabs/workers/WorkersTab";
import * as exportOutsourceDocsActions from "../../actions/exportOutsourceDocsActions";
import StateManager from "../../../shared/utils/StateManager";

class ExportOutsourceDocsCardTabWorkers extends React.Component {

  static TAB_ID = 'workers';

  static renderTabHeader() {
    return (
      <li role="presentation" className="">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_TRABAJADORES').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade" id={ExportOutsourceDocsCardTabWorkers.TAB_ID}>
        <WorkersTab
          id={StateManager.EXP_DOC_TAB_WORKERS}
          companyId={this.props.companyId}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.exportOutsourceDocsActions.checkWorker}
          actionSelectAll={this.props.exportOutsourceDocsActions.checkWorkers}
          selectText={I18nUtils.tr('TR_EXPORTAR')}
          selectAllText={I18nUtils.tr('TR_EXPORTAR_TODO')}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const workerIds = state.exportOutsourceDocs.workers.map(worker => worker.id);
  return {
    selectedIds: workerIds,
  }
};

const mapDispatchToProps = dispatch => ({
  exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsCardTabWorkers)

ExportOutsourceDocsCardTabWorkers.propTypes = {
  companyId: PropTypes.string.isRequired,
};

ExportOutsourceDocsCardTabWorkers.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCardTabWorkers.js